
import { useState, useCallback } from 'react';

const useColorPicker = ({onColorChange,onConfirmation}) => {
    const [color, setColor] = useState('#ffffff');
    const [openColorPicker, setOpenColorPicker] = useState(false);

    const handleColorChange = useCallback((newColor) => {
        setColor(newColor.hex);
        onColorChange && onColorChange(newColor);
    }, []);

    const toggleColorPicker = useCallback(async () => {
        if(openColorPicker && onConfirmation) await onConfirmation(color)
        setOpenColorPicker(prevState => !prevState);
    }, [color,openColorPicker ]);

    return {
        color,
        openColorPicker,
        handleColorChange,
        toggleColorPicker
    };
};

export default useColorPicker;